import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IModule } from 'src/app/interfaces/IModule';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { paths } from 'src/component-paths/component-paths';

@Component({
    selector: 'app-precious-ai',
    templateUrl: './precious-ai.component.html',
    styleUrls: ['./precious-ai.component.css'],
    standalone: false
})
export class PreciousAiComponent {
  @Input() submenu?: IModule[];

  public componentPaths = paths;

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly router: Router
  ) {}

  isInpatientView() {
    return (
      !(
        this.eocService.currentEocId() === null ||
        this.eocService.currentEocId() === ''
      ) && this.router.url.includes('inPatientView')
    );
  }
}
